import React from 'react';
import { Tool, VerifiedIcon } from '../data/tools';
import { ChevronRightIcon } from 'lucide-react';
interface ToolCardProps {
  tool: Tool;
}
const ToolCard = ({
  tool
}: ToolCardProps) => {
  return <div className="border-b border-gray-200 dark:border-dark-border last:border-b-0 hover:bg-[#F8F8F8] dark:hover:bg-dark-background-neutral-soft transition-colors" data-id="element-107">
      <a href={tool.url} target="_top" className="flex items-start md:items-center p-4" data-id="element-108">
        <div className="flex-shrink-0 mr-4" data-id="element-109">
          <div className="w-10 h-10 rounded flex items-center justify-center" data-id="element-110">
            {tool.icon}
          </div>
        </div>
        <div className="flex-1 min-w-0" data-id="element-111">
          <div className="flex items-start md:items-baseline flex-col md:flex-row mb-1" data-id="element-112">
            <div className="flex items-center" data-id="element-113">
              <h3 className="font-medium text-text dark:text-dark-text truncate" data-id="element-114">
                {tool.name}
              </h3>
              {tool.isVerified && <VerifiedIcon data-id="element-115" />}
            </div>
            {tool.followers && <span className="text-xs text-text-meta dark:text-dark-text-meta md:ml-2" data-id="element-116">
                {tool.followers} followers
              </span>}
          </div>
          <p className="text-sm text-text-meta dark:text-dark-text-meta" data-id="element-117">
            {tool.description}
          </p>
        </div>
        <ChevronRightIcon className="flex-shrink-0 w-5 h-5 text-text-meta dark:text-dark-text-meta ml-2" data-id="element-118" />
      </a>
    </div>;
};
export default ToolCard;